export default () => ({
  errors: {},
  password: {
    current: null,
    password: null,
    confirmed: null
  }
})



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/change-password/resources/data.js